import GameManager from '../../../core/GameManager';
import { ScenarioSceneType, ScenarioEndType } from '../../../misc/BleedingControlScenario';
import MainPracticeScenario from './MainTestScenario/MainTestScenario';
import { constants } from '../../../misc/helpers';
import {getTestAScenario} from './testStartText';

export default class PracticeScenarioA extends MainPracticeScenario {
	constructor(gameManager: GameManager, scenarioName: string) {
		var locations = [
			{
				type: constants.placementType.correct1,
				position: 59,
			},
			{
				type: constants.placementType.correct1,
				position: 59,
			},
		];

		var correctT1 = 1;
		var wrongT1 = 1;

		super(gameManager, scenarioName, ScenarioSceneType.scenarioA, ScenarioEndType.pressureDressing, [], true, 0.55, 0.74, locations, null, correctT1, null, wrongT1, null, true, false, false, false, 'Hit By Vehicle - Test Scenario', getTestAScenario());
	}

	public get totalNumberOfQuestions(): number {
		return 2;
	}

	public soundFolderAndPath(section: string, part: string): string {
		return '06-Scenario A/BC-Scenario-A-'  + section + '-Part-' + part;
	}
}